import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import BookingForm from "@/components/BookingForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="bg-[#0a0a0a] text-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <About />
      <BookingForm />
      <Contact />
      <Footer />
    </div>
  );
};

export default Landing;
